// Admin
export const FETCH_ALL_HEALTH_TOPICS_URL = "/healthTopics";
export const DELETE_HEALTH_TOPICS_URL = "/admin/healthTopics";
export const CREATE_HEALTH_TOPICS_URL = "/admin/healthTopics";
export const UPDATE_HEALTH_TOPICS_URL = "/admin/healthTopics";
export const SUGGESTED_TOPICS_URL = "/admin/suggestedTopics";

export const ADMIN_ARTICLES_URL = "/admin/articles";

// User
export const USER_PROFILE_URL = "/users/profiles";
export const USER_DOCUMENTS_URL = "/users/documents";
export const USER_URL = "/users";

// Dashboards
export const ADMIN_TOP_HEALTH_TOPICS = "/admin/topHealthTopics";
export const USER_TOP_HEALTH_TOPICS = "/users/topHealthTopics";
export const ADMIN_COMPLETE_DATA = "/admin/dashboard";
export const ADMIN_COMPLETE_DOCUMENT_DATA = "/admin/dashboard/documents";
